import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ExportApi from "../api/ExportApi";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../pages/home/products/products.css";
import UserContext from "../context/UserContext";
import Login from "./Login";

export default function Favourite(props) {
  let navigate = useNavigate();
  let imageUrl = process.env.REACT_APP_IMAGEBASEURL;
  const [first, setfirst] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [Compare, setCompare] = useState([]);
  const { newlySelectedProducts, setNewlySelectedProducts } = useContext(UserContext);
  const [clickedStates, setClickedStates] = useState({});
  const [openModal, setOpenModal] = useState({});
  const [forgot, setForgot] = useState(false);
  const [signup, setSignup] = useState(false);

  // Function for handling the Compare functionality
  //e used for checking the checkbox is selected or not
  //val used for get the product data
  //i used  for the index
  const handleCompare = (e, val, i) => {
    if (e) {
      val.isCompare = true;
      first[i].isCompare = true;
      setfirst([...first]);
      if (Compare?.length <= 10) {
        const updatedCompare = [...Compare, val];
        setCompare(updatedCompare);
        localStorage.setItem("Compare", JSON.stringify(updatedCompare));
        setModalShow(true);
      }
    } else {
      let data;
      Compare.filter((vall, idx) => {
        if (vall._id == val._id) {
          data = idx;
        }
      });
      val.isCompare = false;
      first[i].isCompare = false;
      setfirst([...first]);
      const updatedCompare = Compare.filter((item) => item._id !== val._id);
      if (updatedCompare?.length > 0) {
        setCompare(updatedCompare);
        localStorage.setItem("Compare", JSON.stringify(updatedCompare));
      } else {
        setCompare([]);
        setModalShow(false);
        localStorage.removeItem("Compare");
        // Update all products to remove isCompare flag
        const updatedFirst = first.map((product) => ({
          ...product,
          isCompare: false
        }));
        setfirst(updatedFirst);
      }
    }
  };

  const HandleCompareClear = () => {
    // Remove comparison and favorite product data from local storage.
    localStorage.removeItem("Compare");
    localStorage.removeItem("FavouriteProducts");

    // Clear the Compare state and close the modal.
    setCompare([]);
    setModalShow(false);

    // Update all products to remove isCompare flag
    const updatedFirst = first.map((product) => ({
      ...product,
      isCompare: false
    }));
    setfirst(updatedFirst);
  };

  // Function for handling the Favorite button
  //data used for check that fav. is true or false
  //id used for the specific product
  //i used for the index
  const HandleFavButton = (data, id, i, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    const userId = JSON.parse(localStorage.getItem("tokenuser"))?.id || JSON.parse(localStorage.getItem("admin"))?.id;
    
    if (!userId) {
      setOpenModal({ ...openModal, [id]: true });
      return;
    }
    
    const isClicked = clickedStates[id] || false;
    const newClickedState = !isClicked;
    
    // Update local state immediately for UI responsiveness
    setClickedStates({ ...clickedStates, [id]: newClickedState });
    let newData = [...first];
    if (newData[i]) {
      newData[i].isfav = newClickedState;
      setfirst([...newData]);
    }
    
    if (newClickedState === false) {
      // Removing from favorites
      ExportApi.RemovetoFevreat(id, userId)
        .then(function (response) {
          ExportApi.favouriteList(userId)
            .then(function (response) {
              setNewlySelectedProducts(response?.data?.data?.favourite || []);
              if (props.HandleGetProductData1) {
                props.HandleGetProductData1(userId);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (error) {
          console.log(error);
          // Revert on error
          setClickedStates({ ...clickedStates, [id]: !newClickedState });
          if (newData[i]) {
            newData[i].isfav = !newClickedState;
            setfirst([...newData]);
          }
        });
    } else {
      // Adding to favorites
      ExportApi.AddtoFevreat(id, userId)
        .then(function (response) {
          ExportApi.favouriteList(userId)
            .then(function (response) {
              setNewlySelectedProducts(response.data.data.favourite || []);
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (error) {
          console.log(error);
          // Revert on error
          setClickedStates({ ...clickedStates, [id]: !newClickedState });
          if (newData[i]) {
            newData[i].isfav = !newClickedState;
            setfirst([...newData]);
          }
        });
    }
  };

  // Function to add a product to the Favorite List
  //id used for the specific product to add in the Favorite List
  const HandleAddtoFav = (id) => {
    if (localStorage.getItem("tokenuser")) {
      ExportApi.AddtoFevreat(
        id,
        JSON.parse(localStorage.getItem("tokenuser")).id
      )
        .then((resp) => {})
        .catch((err) => console.log(err));
    } else {
      ExportApi.AddtoFevreat(id, JSON.parse(localStorage.getItem("admin")).id)
        .then((resp) => {})
        .catch((err) => console.log(err));
    }
  };

  // Function to remove a product from the Favorite List
  //id used for the specified product to remove from the Favorite List
  const HandleRemovetoFav = (id) => {
    if (localStorage.getItem("tokenuser")) {
      ExportApi.RemovetoFevreat(
        id,
        JSON.parse(localStorage.getItem("tokenuser")).id
      )
        .then((resp) => {
          props.HandleGetProductData1(
            JSON.parse(localStorage.getItem("tokenuser")).id
          );
        })
        .catch((err) => console.log(err));
    } else {
      ExportApi.RemovetoFevreat(
        id,
        JSON.parse(localStorage.getItem("admin")).id
      )
        .then((resp) => {
          props.HandleGetProductData1(
            JSON.parse(localStorage.getItem("admin")).id
          );
        })
        .catch((err) => console.log(err));
    }
  };

  // Function for handling Compare functionality for related products
  //e used for checking the checkbox is selected or not
  //val used for get the product data
  //i used  for the index
  const handleRelatedProductCompare = (e, val, i) => {
    if (props.filterData) {
      handleCompare(e, val, i);
    } else {
      props.handleCompare(e, val, i, "Favourite");
    }
  };

  // Function to remove a specific product from the Compare popup
  //the given id is the product id which we remove from the compare popup
  const handleCloseButton = (id) => {
    let result = Compare.filter((item) => item._id != id);
    let data = first;
    for (let i = 0; i < data.length; i++) {
      let element = data[i];
      if (element?._id.includes(id)) {
        data[i].isCompare = false;
      }
    }
    let data2 = JSON.parse(localStorage.getItem("Compare"));
    if (data2?.length == 1) {
      setModalShow(false);
    }
    setfirst([...data]);
    setCompare(result);
    localStorage.setItem("Compare", JSON.stringify(result));
  };
  // Effects for initial data loading and updates
  useEffect(() => {
    if (localStorage.getItem("Compare")) {
      setCompare(JSON.parse(localStorage.getItem("Compare")));
    }
  }, []);

  // Remove modal backdrop when compare modal is shown
  useEffect(() => {
    if (modalShow) {
      const removeBackdrop = () => {
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => {
          backdrop.style.display = 'none';
          backdrop.style.opacity = '0';
          backdrop.style.visibility = 'hidden';
          backdrop.remove();
        });
      };
      
      // Remove immediately
      removeBackdrop();
      
      // Also remove after a short delay to catch any that are added later
      const timer = setTimeout(removeBackdrop, 100);
      
      return () => clearTimeout(timer);
    }
  }, [modalShow]);

  // Sync clickedStates with newlySelectedProducts from context
  useEffect(() => {
    if (newlySelectedProducts && first.length > 0) {
      const newClickedStates = {};
      const updatedFirst = first.map((product) => {
        const isFav = newlySelectedProducts.some((fav) => fav?._id === product?._id);
        newClickedStates[product?._id] = isFav;
        return { ...product, isfav: isFav };
      });
      setClickedStates(newClickedStates);
      setfirst(updatedFirst);
    }
  }, [newlySelectedProducts]);

  useEffect(() => {
    if (props.filterData) {
      let data1 = props.filterData;
      let data2 = data1;
      let result = JSON.parse(localStorage.getItem("Compare"));
      for (let i = 0; i < result?.length; i++) {
        const element = result[i];
        for (let index = 0; index < data2.length; index++) {
          const element1 = data2[index];

          if (element?._id.includes(element1?._id)) {
            data2[index].isCompare = true;
          }
          setfirst(data2);
        }
      }
      setfirst(data2);
    } else {
      let data1 = props.data?.favourite;
      if (data1) {
        for (let index = 0; index < props.data?.favourite.length; index++) {
          data1[index].isfav = true;
          let data2 = data1;
          let result = JSON.parse(localStorage.getItem("Compare"));
          for (let i = 0; i < result?.length; i++) {
            const element = result[i];
            for (let index = 0; index < data2.length; index++) {
              const element1 = data2[index];

              if (element?._id.includes(element1?._id)) {
                data2[index].isCompare = true;
              }
            }
          }
          setfirst(data2);
        }
      } else {
        setfirst(data1);
      }
    }
  }, [props.data]);

  // Favourite svg style
  const getSvgStyle = (isfav) => ({
    width: "20px",
    height: "20px",
    fill: isfav ? "red" : "transparent",
    stroke: "black",
    strokeWidth: isfav ? "0" : 1,
    cursor: "pointer",
  });

  const handleProductClick = (e, slug) => {
  e.preventDefault();
  window.open(`/product/${slug}`, "_blank");
};

  return (
    <div className="product_all_view py-4">
      <Container>
        <h1 className="fs-4 mb-3 text-capitalize">{props.Title}</h1>

        <div className="products-container">
          <div className="products-list row">
            {first?.map((val, i) => {
              if (i > 5) return null;
              
              const price = val?.type == 1
                ? val?.new_retail_website_price
                : val?.lowest_ask > 0
                ? val?.lowest_ask
                : "TBD";

              const isFirstProduct = i === 0;

              return (
                <div className="mb-3 col-6 col-md-4 col-xl-2 position-relative d-flex" key={i}>
                  <div className="product-box p-3 position-relative w-100">
                    <span
                      className="d-flex position-absolute"
                      style={{
                        color:
                          val?.chipset === "AMD"
                            ? "rgba(153, 0, 0, 0.5)"
                            : val?.chipset === "Nvidia"
                            ? "rgba(0, 102, 0, 0.5)"
                            : "inherit",
                        zIndex: 10,
                        pointerEvents: 'none'
                      }}
                    >
                      {val?.chipset}
                    </span>
                    <div className="product-body mt-2 mt-xl-3 w-100">
                      <div 
                        className={`product-image-wrapper ${isFirstProduct ? 'first-product-image' : ''}`}
                        onClick={(e) => handleProductClick(e, val?.slug)}
                      >
                        {/* <LazyLoadImage
                          src={
                            val?.image[0]?.startsWith("http")
                              ? val?.image[0]
                              : `${imageUrl}${val?.image[0]}`
                          }
                          alt="product"
                          effect="blur"
                        /> */}
                       <img src={val?.image[0]} alt="thumbnail" />

                      </div>
                    <div className="product-content">
                      <div className="product-details w-100">
                        <div className="desc" onClick={(e) => handleProductClick(e, val?.slug)}>
                          <p className="text-start mb-0 !min-h-0 product-title-with-icon">
                            <svg
                              viewBox="0 0 17 17"
                              className="sc-beqWaB ixusxy hear-icon hear-icon-mobile"
                              xmlns="http://www.w3.org/2000/svg"
                              style={getSvgStyle(clickedStates[val?._id] || val?.isfav)}
                              onClick={(e) => {
                                console.log("this worksssssssssssss")
                                HandleFavButton(!(clickedStates[val?._id] || val?.isfav), val?._id, i, e);
                              }}
                              onTouchStart={(e) => {
                                HandleFavButton(!(clickedStates[val?._id] || val?.isfav), val?._id, i, e);
                              }}
                            >
                              <path
                                fillRule="evenodd"
                                d="M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
                              ></path>
                            </svg>
                          </p>
                          <p className="text-start mb-0">
                            <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>{val?.brand}</span>
                          </p>
                          <p className="text-start mb-0">
                            <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>{val?.series}</span>
                          </p>
                          <p className="text-start mb-0" style={{ 
                                      fontWeight: 'normal', 
                                      fontSize: '12.6px', 
                                      lineHeight: '12.6px', 
                                      height: '2.4em', 
                                      whiteSpace: 'normal', 
                                      overflow: 'hidden', 
                                      marginTop: '5px'
                                    }}>
                            {val?.model}
                          </p>
                          <p className="text-start fw-bold condition" 
                                    style={{ 
                                      color: '#0b4068',
                                      fontSize: '12.6px', 
                                      lineHeight: '12.6px', 
                                    }}>
                            Condition:{" "}
                            {val?.type == 1
                              ? "New-Retail"
                              : val?.type == 2
                              ? "New"
                              : "Used"}
                          </p>
                          <div className="d-flex align-items-center justify-content-between w-100">
                            <h5 className="fw-bold product-price mb-0">
                              {price == "TBD" ? "TBD" : "$" + price}
                            </h5>
                            <div 
                              className="compare d-flex align-items-center"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <label 
                                htmlFor={`compare-${val?._id}`} 
                                className="mb-0 me-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              >
                                Compare
                              </label>
                              <input
                                type="checkbox"
                                id={`compare-${val?._id}`}
                                checked={val?.isCompare ? true : false}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  handleCompare(
                                    e.target.checked,
                                    val,
                                    i,
                                    "ProductList"
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <svg
                          viewBox="0 0 17 17"
                          className="sc-beqWaB ixusxy hear-icon hear-icon-desktop"
                          xmlns="http://www.w3.org/2000/svg"
                          style={getSvgStyle(clickedStates[val?._id] || val?.isfav)}
                          onClick={(e) => {
                            HandleFavButton(!(clickedStates[val?._id] || val?.isfav), val?._id, i, e);
                          }}
                        >
                          <path
                            fillRule="evenodd"
                            d="M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          </div>
        </div>
      </Container>

      {/* Login Modals for each product */}
      {first?.map((val, i) => {
        if (i > 5) return null;
        return (
          <Modal
            key={`modal-${val?._id}`}
            show={openModal[val?._id] || false}
            onHide={() => setOpenModal({ ...openModal, [val?._id]: false })}
            backdrop={true}
            keyboard={false}
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="scrollable-modal-body">
                   <Login
                      setSignup={setSignup}
                      setForgot={setForgot}
                      signup={signup}
                      forgot={forgot}
                      modal={() => setOpenModal({ ...openModal, [val?._id]: false })} />
            </Modal.Body>
          </Modal>
        );
      })}
      
      <style>{`
        .products-container .products-list .product-box {
          border: 1px solid #dee2e6;
          border-radius: 11px;
          transition: all 0.3s ease;
        }
        .products-container .products-list .product-box:hover {
          border-color: #adb5bd;
        }
        .products-container .products-list .product-box .product-body {
          transition: transform 0.3s ease;
        }
        .products-container .products-list .product-box:hover .product-body {
          transform: scale(1.05);
        }
        .products-container .products-list .product-box .product-image-wrapper.first-product-image img {
          transition: transform 0.3s ease, opacity 0.3s ease;
        }
        .products-container .products-list .product-box:hover .product-image-wrapper.first-product-image img {
          transform: scale(1.15);
          opacity: 0.9;
        }
        .products-container .products-list .product-box .product-image-wrapper img {
          transition: transform 0.3s ease;
        }
        .products-container .products-list .product-box:hover .product-image-wrapper img {
          transform: scale(1.1);
        }
        .products-container .products-list .product-box .compare input[type="checkbox"] {
          border-radius: 0.25em;
          // background-color: #fff;
          border: 1px solid rgba(0, 0, 0, 0.25);
          height: 1em;
          width: 1em;
          cursor: pointer;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          position: relative;
          transition: all 0.2s ease;
        }
        .products-container .products-list .product-box .compare input[type="checkbox"]:checked {
          background-color: #0d6efd;
          border-color: #0d6efd;
        }
        .products-container .products-list .product-box .compare input[type="checkbox"]:checked::after {
          content: "✓";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 0.75em;
          font-weight: bold;
          line-height: 1;
        }
        .main_compare_box.compare_product_menu {
          transition: none !important;
          animation: none !important;
          box-shadow: none !important;
        }
        .compare-modal.custom-model {
          transition: none !important;
          animation: none !important;
        }
        .compare-modal.custom-model .modal-content {
          transition: none !important;
          animation: none !important;
          box-shadow: none !important;
        }
        .compare-modal.custom-model ~ .modal-backdrop,
        .compare-modal.custom-model + .modal-backdrop,
        .modal-backdrop.fade,
        .modal-backdrop.show,
        .modal-backdrop {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
          background: transparent !important;
        }
        body.modal-open {
          padding-right: 0 !important;
          overflow: visible !important;
        }
        .compare-modal.custom-model {
          pointer-events: auto !important;
        }
        .compare-modal.custom-model .modal-dialog {
          box-shadow: none !important;
        }
        .compare-modal.custom-model .modal-content {
          border: none !important;
          box-shadow: none !important;
        }
      `}</style>

      {/* Start Open Compare Modal  */}
      {props.filterData && (
        <Modal
          show={modalShow}
          className="compare-modal custom-model"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop={false}
          centered
          animation={false}
        >
          <div className="d-flex flex-coloumn">
            <Modal.Body className="scrollable-modal-body">
              <div className="model-custom-inner">
                {Compare.map((Compare, i) => {
                  return (
                    <div
                      className="inner-pro-cont border p-3 position-relative"
                      id="modal-inner-cont"
                      key={i}
                    >
                      <button
                        className="close-box"
                        onClick={() => handleCloseButton(Compare._id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fillRule="currentColor"
                          className="bi bi-x"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                        </svg>
                      </button>
                      <div className="d-flex gap-2">
                        <div>
                          {Compare?.chipset == "Nvidia" ? (
                            <p className="up-text position-absolute fw-bold toptext">
                              {Compare?.chipset}
                            </p>
                          ) : Compare?.chipset == "AMD" ? (
                            <p className="chipset-text position-absolute fw-bold toptext">
                              {Compare?.chipset}
                            </p>
                          ) : Compare?.chipset == "AYU" ? (
                            <p className="up-down-text position-absolute fw-bold toptext">
                              {Compare?.chipset}
                            </p>
                          ) : (
                            <p className="chipset-text position-absolute fw-bold toptext">
                              {Compare?.chipset}
                            </p>
                          )}
                          <LazyLoadImage
                            // src={`${imageUrl}${Compare?.image[0]}`}
                            src={
                              Compare?.image[0]?.startsWith("http")
                                ? Compare?.image[0]
                                : `${imageUrl}${Compare?.image[0]}`
                            }
                            effect="blur"
                          />
                        </div>
                        <div className="custom-model-body text-start">
                          <p className=" w-full mb-0">
                            {Compare?.brand}
                            <div className="w-25 text-end"></div>
                          </p>
                          <p className="mb-0">{Compare?.model}</p>
                          <p className="mb-0">{Compare?.category?.name}</p>
                          <div className="bl-text">
                            <p className="mb-0">
                              Condition:{" "}
                              {Compare?.type == 1
                                ? "New"
                                : Compare?.type == 2
                                ? "New(Resale)"
                                : "Used(Tested)"}
                            </p>
                            <p className="mb-0">{Compare?.condition} </p>
                          </div>
                          <h2 className=" fw-bold">
                            {Compare?.type == 1
                              ? "$" + Compare?.new_retail_website_price
                              : Compare?.type == 2
                              ? Compare.new_second_hand_house_ask
                                ? "$" + Compare?.new_second_hand_house_ask
                                : ""
                              : Compare.used_house_ask
                              ? "$" + Compare?.used_house_ask
                              : ""}
                          </h2>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center mt-3">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fillRule="#b8b8b8"
                  className="bi bi-dash-circle position-absolute end-0 top-0 me-5 mt-3"
                  viewBox="0 0 16 16"
                  onClick={() => setModalShow(false)}
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
              </div>

              <Button
                varient="primary"
                className="px-4"
                onClick={() => navigate("/compareBuySell")}
              >
                Compare
              </Button>
              {props.Title == "Related product" ? (
                <Button
                  className="px-4 bg-transparent text-blue border-0"
                  onClick={() => {
                    setfirst();
                    setCompare([]);
                    setModalShow(false);
                    localStorage.removeItem("Compare");
                    localStorage.removeItem("FavouriteProducts");
                    props.RelatedProductCompare();
                  }}
                >
                  Clear All
                </Button>
              ) : (
                <Button
                  className="px-4 bg-transparent text-blue border-0"
                  onClick={() => {
                    setfirst();
                    setCompare([]);
                    setModalShow(false);
                    setTimeout(() => {
                      setfirst([...props.filterData]);
                    }, 1000);
                    localStorage.removeItem("Compare");
                  }}
                >
                  Clear All
                </Button>
              )}
            </Modal.Footer>
          </div>
        </Modal>
      )}
      {/* End Open Compare Modal */}

      {/* Start Compare Button */}
      {props.filterData && Compare[0]?._id && (
        <div className="main_compare_box compare_product_menu">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="compare_product_button">
                  <Button
                    varient="primary"
                    className="px-4"
                    onClick={() => setModalShow(!modalShow)}
                  >
                    Compare
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
      {/* End Compare Button */}
    </div>
  );
}
